import { useTranslation } from 'react-i18next'
import { LogisticsKRCar } from 'views/pages/LogisticsKR/types'

export const useCarsParams = (car: LogisticsKRCar) => {
  const { t } = useTranslation('logisticsKR')
  const carInfo = [
    car.car_type && t(`vehicle_type.${car.car_type}`),
    car.is_dump_truck && t('warehouses.details.is_dump_truck'),
    car.unloading_type && t(`directions.${car.unloading_type}`),
    car.side_height && t('warehouses.details.values.scales_length', { scales_length: car.side_height }),
  ]
    .filter(Boolean)
    .join(', ')

  const extraInfo = [`${t('vehicles:charter')}: ${car.is_in_charter ? t('common:yes') : t('common:no')}`].join(', ')
  return {
    carInfo,
    extraInfo,
  }
}
